<template>
  <div>
    <h2 style="text-align: center; font-size: 20px">
      <span>司机APP注销协议</span>
    </h2>
    <p>
      <span>在您注销您的快线APP账号之前，请充分阅读、理解并同意下列事项：</span>
    </p>
    <p>
      <span
        >在此善意地提醒您，您注销本快线APP账号的行为，将导致我们终止对您提供本服务，也会给您的售后维权带来诸多不便。注销成功后，我们将删除您的个人信息，使其保持不可被检索、访问的状态，或对其进行匿名化处理。</span
      >
    </p>

    <p>
      <span
        >1、如果您仍执意注销本快线APP账号，您的快线APP账号需同时满足以下条件：</span
      ><br />
      <span>（1）账号内无未结算的费用；</span><br />
      <span>（2）账号内无未完成的订单；</span>
    </p>
    <p>
      <span
        >2、在快线APP账号注销期间，如果您的快线APP账号涉及争议纠纷，包括但不限于投诉、举报、诉讼、仲裁、国家有权机关调查等，我们有权自行终止快线APP账号的注销而无需另行得到您的同意。</span
      >
    </p>
    <p>
      <span
        >3、快线APP账号一旦被注销将不可恢复，请您在操作之前自行备份快线APP账号相关的所有信息和数据。注销快线APP账号，您将无法再使用快线APP账号，也将无法找回您快线APP账号内所有历史记录信息（即使您使用相同的手机号码再次注册并使用），包括但不限于：</span
      ><br />
      <span>（1）您将无法登录、使用快线APP账号；</span><br />
      <span
        >（2）快线APP账号的个人资料和历史信息（包括但不限于用户名、昵称、头像等）都将无法找回；</span
      ><br />
      <span
        >（3）您通过快线APP账号进行登录的快线APP旗下各模块（包括但不限于配送、家电服务、自仓自配等）所有记录将无法找回。您将无法再登录、使用前述服务，您曾获得的积分等视为您自行放弃，将无法继续使用。您理解并同意，快线APP无法协助您重新恢复前述服务。</span
      ><br />
    </p>
    <p>
      <span
        >4、注销本快线APP账号并不代表本快线APP账号注销前的账号行为和相关责任得到豁免或减轻。</span
      >
    </p>
  </div>
</template>

<script>
export default {};
</script>

<style>
p {
  padding: 0 12px;
  font-size: 14px;
  color: #000000;
  text-align: left;
  font-family: 宋体;
}
</style>